import { useDeleteProfilePhotoMutation } from "Api/Mutations/User/useDeleteProfilePhotoMutation";
import { useUploadProfilePhotoMutation } from "Api/Mutations/User/useUploadProfilePhotoMutation";
import { FormSection } from "Components/Shared/FormSection";
import { ProfilePhotoEditor } from "Components/Shared/ProfilePhoto/ProfilePhotoEditor";
import { useLoggedInUser } from "Hooks/useLoggedInUser";
import { toast } from "sonner";
import { Resources, useResource } from "Translations/Resources";
import { getAvatarPhotoUrl } from "Utils/Image/getProfilePhotoUrl";

const RESOURCES = Resources.Components.UserAccount.ProfilePhoto;

/** The signed-in persona's own avatar (the active role context's photo). */
export const ProfilePhotoSection = () => {
  const { t } = useResource();
  const user = useLoggedInUser();

  const { mutateAsync: uploadPhoto, isPending: isUploading } =
    useUploadProfilePhotoMutation({
      onSuccess: () => toast.success(t(RESOURCES.UploadSuccess)),
      onError: () => toast.error(t(RESOURCES.UploadError)),
    });

  const { mutate: deletePhoto, isPending: isDeleting } =
    useDeleteProfilePhotoMutation({
      onSuccess: () => toast.success(t(RESOURCES.DeleteSuccess)),
      onError: () => toast.error(t(RESOURCES.DeleteError)),
    });

  if (!user) {
    return null;
  }

  const {
    firstName,
    lastName,
    login,
    userPublicID,
    profilePicture,
    activeContextPublicID,
  } = user;
  const previewUrl = getAvatarPhotoUrl(
    userPublicID,
    activeContextPublicID,
    profilePicture,
  );
  const acronym = (
    firstName && lastName ? `${firstName[0]}${lastName[0]}` : login[0]
  ).toLocaleUpperCase();

  return (
    <FormSection noMargins>
      <ProfilePhotoEditor
        previewUrl={previewUrl}
        fallback={acronym}
        hint={t(RESOURCES.Hint)}
        removeConfirmMessage={t(RESOURCES.RemoveConfirm)}
        isUploading={isUploading}
        isDeleting={isDeleting}
        onUpload={(photo) => uploadPhoto({ file: photo })}
        onDelete={deletePhoto}
      />
    </FormSection>
  );
};
